export const PANEL_MOTION_MS = 260;
export const PANEL_ENTRY_TIMEOUT_MS = 340;

export function setTaskPanelFocus(open: boolean, root: ParentNode = document): void {
  document.body.classList.toggle("task-view-open", open);
  root.querySelectorAll<HTMLElement>(".workspace, .sidebar").forEach(region => {
    region.inert = open;
  });
}

export async function animateRightPanelClose(panel: HTMLElement | null, backdrop: HTMLElement | null): Promise<void> {
  if (!panel || prefersReducedMotion()) return;
  panel.classList.add("is-closing");
  backdrop?.classList.add("is-closing");
  await new Promise(resolve => window.setTimeout(resolve, PANEL_MOTION_MS));
}

export async function waitForTaskPanelEntry(taskId: string, selectedTaskId: string | null, root: ParentNode = document, timeoutMs = PANEL_ENTRY_TIMEOUT_MS): Promise<void> {
  const panel = root.querySelector<HTMLElement>(".detail-panel");
  if (!panel || selectedTaskId !== taskId || !panel.matches(":is(.is-preparing,.is-entering)")) return;
  await new Promise<void>(resolve => {
    const finish = () => { window.clearTimeout(timeout); panel.removeEventListener("animationend", onAnimationEnd); resolve(); };
    const timeout = window.setTimeout(finish, timeoutMs);
    const onAnimationEnd = (event: Event) => {
      if (event.target === panel && (event as AnimationEvent).animationName === "panel-in") finish();
    };
    panel.addEventListener("animationend", onAnimationEnd);
  });
}

export function focusPanelComment(id: string, motionBehavior: ScrollBehavior, root: ParentNode = document, requestFrame: (callback: FrameRequestCallback) => number = requestAnimationFrame): void {
  requestFrame(() => requestFrame(() => {
    const comment = [...root.querySelectorAll<HTMLElement>("[data-comment-id]")].find(item => item.dataset.commentId === id);
    comment?.scrollIntoView({ behavior: motionBehavior, block: "center" });
    comment?.classList.add("is-targeted");
  }));
}

function prefersReducedMotion(): boolean {
  return typeof window.matchMedia === "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
